var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgAccordionCarat = function SvgAccordionCarat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 29,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.37.769l20.952 21.267a2.654 2.654 0 010 3.714l-2.444 2.48a2.56 2.56 0 01-3.654.005L23.54 11.38 6.857 28.234a2.56 2.56 0 01-3.655-.004L.758 25.749a2.654 2.654 0 010-3.714L21.71.77a2.56 2.56 0 013.66 0z",
    fill: "#0061A0"
  })));
};

export default SvgAccordionCarat;